const LanguageCode = "hi";
document.body.classList.add(LanguageCode + "-body");
const Globals = {
  LanguageCode : "hi",
  language_based_api:"https://ws-n.webdunia.com/json/page?lang=hi&url=/",
  Desktop_language_based_api:"https://api-en.webdunia.com/api/v3/get-menu-by-Id?lang=hi&menuType=NavigationMenu&menuId=1",
  Desktop_header_based_api: "https://api-en.webdunia.com/api/v3/get-menu-by-Id?lang=hi&menuType=NavigationMenu&menuId=1",
  Desktop_footer_based_api:"https://api-en.webdunia.com/api/v3/get-menu-by-id?lang=hi&menuType=FooterMenu&menuId=1",
};
export default Globals;
